import { render, staticRenderFns } from "./RoiTable.vue?vue&type=template&id=295f7933"
import script from "./RoiTable.vue?vue&type=script&lang=js"
export * from "./RoiTable.vue?vue&type=script&lang=js"
import style0 from "./RoiTable.vue?vue&type=style&index=0&id=295f7933&prod&lang=scss"
import style1 from "./RoiTable.vue?vue&type=style&index=1&id=295f7933&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports